"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAdornment = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _AdornmentMixin = require("../../mixins/components/AdornmentMixin");
var _doNotForwardTransientProp = require("../../util/doNotForwardTransientProp");
var StyledAdornment = /*#__PURE__*/(0, _styledComponents.default)('label').withConfig({
  shouldForwardProp: (0, _doNotForwardTransientProp.doNotForwardTransientProp)(['disabled', 'readOnly'])
}).withConfig({
  displayName: "StyledAdornment",
  componentId: "c11n-8-107-0__sc-1h2m3pa-0"
})(["", ""], _AdornmentMixin.AdornmentMixin);
exports.StyledAdornment = StyledAdornment;